module.exports = __webpack_public_path__ + "img/2.638d8eb.jpg";